import React, { Component } from 'react'
import { Row, Table, Button, Modal, Select, Popconfirm } from 'antd'
import { app } from "../../app"
import NewsAdd from "./News/NewsAdd"
import NewsPushWhiteList from "./News/NewsPushWhiteList"
import api from "../../api"
import NewsReviewWhiteList from "./News/NewsReviewWhiteList"
import utils from "../../utils"
import NewsDetail from "../../components/NewsDetail"
import NewsRecord from "./News/NewsRecord"
import config from "../../config"

class NewsTeam extends Component {
    constructor (props) {
        super(props)
        this.state = {
            add_modal_visible: false,
            pushwhite_modal_visible: false,
            pushreview_modal_visible: false,
            record_modal_visible: false,
            dataList: [],
            detail_data: {},
            edit_id: null,
            record_id: null,
            dataLevel: '0',
            detail_visible: false,
            total: 0,
            page: 1,
            news_type: '1'
        }
    }

    componentDidMount () {
        this._isMounted = true
        this.handleNewsData()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    /**
     * 新闻数据
     * @returns {Promise<void>}
     */
    handleNewsData = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        let { news_type, dataLevel } = this.state, params = {
            page,
            search_type: 'searchform_level',
            search_val: dataLevel,
            type: news_type,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, data, msg, total } = await app.post(api.NewsReleaseList, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        await this.setData({ dataList: utils.addArrayKey(data), data_loading: false, total: Number(total || 0) })
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 关闭发布新闻对话框
     */
    handleCloseAddModal = async (flag) => {
        await this.setData({ add_modal_visible: false })
        if (flag) {
            await this.handleNewsData()
        }
    }

    /**
     * 打开发布新闻对话框
     */
    handleOpenAddModal = () => {
        this.setData({ edit_id: null, add_modal_visible: true })
    }

    /**
     * 关闭发布新闻白名单对话框
     */
    handleClosePushWhiteModal = () => {
        this.setData({ pushwhite_modal_visible: false })
    }

    /**
     * 打开发布新闻白名单对话框
     */
    handleOpenPushWhiteModal = () => {
        this.setData({ pushwhite_modal_visible: true })
    }

    /**
     * 关闭审核新闻白名单对话框
     */
    handleCloseReviewWhiteModal = () => {
        this.setData({ pushreview_modal_visible: false })
    }

    /**
     * 打开审核新闻白名单对话框
     */
    handleOpenReviewWhiteModal = () => {
        this.setData({ pushreview_modal_visible: true })
    }

    /**
     * 状态筛选变更
     * @param value
     */
    handleStateChange = async (value) => {
        await this.setData({ news_type: value })
        await this.handleNewsData(1)
    }

    /**
     * 关闭详情
     */
    handleCancelDetail = () => {
        this.setData({ detail_visible: false })
    }

    /**
     * 关闭
     */
    handleCancelRecord = () => {
        this.setData({ record_id: null, record_modal_visible: false })
    }

    /**
     * 打开详情
     */
    handleOpenDetail = async (id, type) => {
        await this.setData({ detail_visible: true, detail_loading: true })
        let state = { detail_loading: false }
        if (type) {
            let { flag, data, msg } = await app.post(api.NewsOperateDetails, {
                id,
                type,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            })
            if (flag === 1) {
                state.detail_data = data
            } else {
                app.alert(msg, 'error')
            }
        } else {
            let { flag, data, msg } = await app.post(api.NewNewsDetails, {
                id,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            })
            if (flag === 1) {
                state.detail_data = data
            } else {
                app.alert(msg, 'error')
            }
        }
        await this.setData(state)
    }

    /**
     * 编辑
     * @param edit_id
     */
    handleEdit = async (edit_id) => {
        this.setData({ add_modal_visible: true, edit_id })
    }

    /**
     * 删除
     * @param id
     */
    handleDelete = async (id) => {
        let { flag, msg } = await app.post(api.NewsDel, {
            id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        })
        if (flag === 1) {
            app.alert('删除成功', 'success')
            const { page, total } = this.state
            let tp = parseInt((total - 1) / 20)
            tp = (total - 1) % 20 === 0 ? tp : tp + 1
            if (tp >= page) {
                tp = page
            }
            await this.handleNewsData(tp)
        } else {
            app.alert(msg, 'error')
        }
    }

    /**
     * 打开操作记录
     * @param record_id
     */
    handleOpenRecord = (record_id) => {
        this.setData({ record_modal_visible: true, record_id })
    }

    /**
     * 打开推荐选择
     * @param id
     */
    handleOpenRecommend = async (id) => {
        let { flag, data, msg } = await app.post(api.NewsRecommendList, {
            id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        })
        if (flag === 1) {
            let level = null
            Modal.confirm({
                title: "推荐等级",
                centered: true,
                destroyOnClose: true,
                width: 600,
                okText: "确定",
                content: (
                    <div>
                        <Select style={{ width: 300 }} placeholder="请选择推荐等级" onChange={(val) => {
                            level = val
                        }}>
                            {
                                data.map((r, i) => {
                                    return (
                                        <Select.Option key={i} value={r.recommend}>{r.recommend_name}</Select.Option>
                                    )
                                })
                            }
                        </Select>
                        <p style={{ color: 'red' }}>注: 推荐后需要重新审核方可对外公布</p>
                    </div>
                ),
                onOk: async () => {
                    if (!level) {
                        app.alert('请选择推荐等级', 'warn')
                        return Promise.reject(false)
                    }
                    let res = await app.post(api.NewsRecommend, {
                        id,
                        recommend: level,
                        indexno: app.getData('indexno'),
                        account: app.getData('account'),
                    })
                    if (res.flag === 1) {
                        app.alert(res.msg, 'success')
                    } else {
                        app.alert(res.msg, 'error')
                    }
                }
            })
        } else {
            app.alert(msg, 'error')
        }
    }

    render () {
        let {
                detail_visible, detail_data, detail_loading, news_type, dataList, data_loading, add_modal_visible,
                pushwhite_modal_visible, pushreview_modal_visible, edit_id, record_id, record_modal_visible, page, total
            } = this.state,
            rights = app.getData('rights'),
            columns = [
                {
                    title: '封面图片',
                    dataIndex: 'news_img',
                    key: 'news_img',
                    width: '12%',
                    render: (img) => {
                        if (img) {
                            let src = config.imgUrl + img
                            return (
                                <a href={src} target='_blank'>
                                    <img width={80} height={80} src={src}/>
                                </a>
                            )
                        } else {
                            return '已清除'
                        }
                    }
                },
                {
                    title: '标题',
                    dataIndex: 'news_title',
                    key: 'news_title',
                    render: (title) => (
                        <span title={title}>{title.length > 20 ? title.substr(0, 20) + '...' : title}</span>)
                },
                {
                    title: '级别',
                    dataIndex: 'object_type',
                    key: 'object_type',
                    width: '10%',
                    render (type) {
                        switch (type) {
                            case '1':
                                return (<span>全国</span>)
                            case '2':
                                return (<span>省级</span>)
                            case '3':
                                return (<span>队伍</span>)
                            default:
                                return ''
                        }
                    }
                },
                {
                    title: '推荐级别',
                    dataIndex: 'recommend_before',
                    key: 'recommend_before',
                    width: '10%',
                    render (rb, record) {
                        return rb + (record.recommend_after ? ` -> ${record.recommend_after}` : '')
                    }
                },
                {
                    title: '发布对象',
                    dataIndex: 'object',
                    key: 'object',
                    width: '12%',
                },
                {
                    title: '发布时间',
                    dataIndex: 'release_time',
                    key: 'release_time',
                    width: '12%',
                    render: (_) => (<span>{_ || '-'}</span>)
                },
                {
                    title: '操作',
                    dataIndex: 'id',
                    key: 'id',
                    width: '15%',
                    render: (id, { object_type }) => {
                        return (
                            <div>
                                <div>
                                    <Button size="small" type="primary"
                                            onClick={() => this.handleOpenDetail(id)}>详情</Button>
                                </div>
                                {news_type === '1' ? (
                                    <div>
                                        <div>
                                            <Button size="small" type="primary" style={{ marginTop: 10 }}
                                                    onClick={() => this.handleEdit(id)}>编辑</Button>
                                        </div>
                                        <Popconfirm placement="bottom"
                                                    title="确定删除吗？"
                                                    cancelText="取消"
                                                    okText="确定"
                                                    onConfirm={() => this.handleDelete(id)}
                                        >
                                            <div>
                                                <Button size="small" type="danger" style={{ marginTop: 10 }}>删除</Button>
                                            </div>
                                        </Popconfirm>
                                        {
                                            object_type !== '1' ? (
                                                <div>
                                                    <Button size="small" type="primary" style={{ marginTop: 10 }}
                                                            onClick={() => this.handleOpenRecommend(id)}>推荐到</Button>
                                                </div>
                                            ) : null
                                        }
                                    </div>) : null}

                                <div>
                                    <Button size="small" type="primary" style={{ marginTop: 10 }}
                                            onClick={() => this.handleOpenRecord(id)}>操作记录</Button>
                                </div>
                            </div>)
                    }
                },
            ]
        return (
            <div className="ranks_content">
                <Row type="flex" justify="space-between" align="middle">
                    <h1 style={{ color: '#444' }}>新闻管理</h1>
                    <span>
                        {
                            '13'.indexOf(rights) !== -1 ?
                                (<Button type="primary" key="1" style={{ marginRight: 20 }}
                                         onClick={this.handleOpenPushWhiteModal}>发布白名单</Button>) : null
                        }
                        {
                            rights === 1 ? (<Button type="primary" key="2" style={{ marginRight: 20 }}
                                                    onClick={this.handleOpenReviewWhiteModal}>审核白名单</Button>) : null
                        }
                        <Button type="primary" onClick={this.handleOpenAddModal}>发布新闻</Button>
                    </span>
                </Row>
                <div style={{ marginBottom: 12 }}>
                    <span>新闻状态: </span>
                    <Select defaultValue="1" style={{ width: 200 }} onChange={this.handleStateChange}>
                        <Select.Option value="1">已发布</Select.Option>
                        <Select.Option value="2">已删除</Select.Option>
                    </Select>
                    <span style={{ marginLeft: 20 }}>级别选择： </span>
                    <Select defaultValue="0" style={{ width: 120, marginBottom: 20 }} onChange={async (value) => {
                        await this.setData({ dataLevel: value })
                        await this.handleNewsData(1)
                    }}>
                        <Select.Option value="0">全部</Select.Option>
                        <Select.Option value="1">全国</Select.Option>
                        <Select.Option value="2">省级</Select.Option>
                        <Select.Option value="3">队伍</Select.Option>
                    </Select>
                </div>
                <Table size="small"
                       locale={app.tbLocale(data_loading)}
                       columns={columns}
                       dataSource={dataList}
                       loading={data_loading}
                       pagination={{
                           current: page,
                           total,
                           pageSize: 20,
                           showTotal: (t) => `总数量：${t}`,
                           onChange: this.handleNewsData
                       }}
                       scroll={{ y: 'calc(100vh - 334px)' }}
                />
                <Modal
                    visible={add_modal_visible}
                    title="发布新闻"
                    footer={null}
                    width="100%"
                    maskClosable={false}
                    destroyOnClose={true}
                    onCancel={this.handleCloseAddModal}
                    style={{ top: 0, padding: 20 }}
                    bodyStyle={{ height: 'calc(100vh - 95px)', overflowY: 'auto' }}
                >
                    <NewsAdd edit_id={edit_id} onClose={this.handleCloseAddModal}/>
                </Modal>
                <Modal
                    visible={pushwhite_modal_visible}
                    title="发布新闻白名单"
                    footer={null}
                    width="calc(100% - 40px)"
                    maskClosable={false}
                    destroyOnClose={true}
                    onCancel={this.handleClosePushWhiteModal}
                    bodyStyle={{ minHeight: 'calc(100vh - 100px)' }}
                    style={{ top: 20, bottom: 20 }}
                >
                    <NewsPushWhiteList/>
                </Modal>
                <Modal
                    visible={pushreview_modal_visible}
                    title="审核【全国】新闻白名单"
                    footer={null}
                    width="calc(100% - 40px)"
                    maskClosable={false}
                    destroyOnClose={true}
                    onCancel={this.handleCloseReviewWhiteModal}
                    bodyStyle={{ minHeight: 'calc(100vh - 100px)' }}
                    style={{ top: 20, bottom: 20 }}
                >
                    <NewsReviewWhiteList/>
                </Modal>
                <Modal
                    visible={detail_visible}
                    footer={null}
                    title="新闻详情"
                    maskClosable={false}
                    width='100%'
                    style={{ top: 0, height: '100vh' }}
                    bodyStyle={{ height: 'calc(100vh - 55px)', overflow: 'auto' }}
                    onCancel={this.handleCancelDetail}
                    zIndex={1010}
                    className="news-detail-modal-class"
                >
                    <NewsDetail data={detail_data} review loading={detail_loading}/>
                </Modal>
                <Modal
                    visible={record_modal_visible}
                    footer={null}
                    title="操作记录"
                    maskClosable={false}
                    width='100%'
                    style={{ top: 0, height: '100vh', minWidth: 1200 }}
                    bodyStyle={{ height: 'calc(100vh - 55px)', overflow: 'auto' }}
                    onCancel={this.handleCancelRecord}
                    destroyOnClose={true}
                >
                    <NewsRecord record_id={record_id} openDetail={this.handleOpenDetail}/>
                </Modal>
            </div>
        )
    }
}

export default NewsTeam



// WEBPACK FOOTER //
// ./src/routes/ranks/NewsTeam.jsx